module.exports = __webpack_public_path__ + "img/franchising_why_3.8c1319b9.svg";